import { render, staticRenderFns } from "./StakingCategorization.vue?vue&type=template&id=e30f8c8c&"
import script from "./StakingCategorization.vue?vue&type=script&lang=js&"
export * from "./StakingCategorization.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports